import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alert-bag justify-center"},_vm._l((_vm.alerts),function(alert){return _c(VAlert,{key:alert.id,staticClass:"alert-bag__alert",attrs:{"type":alert.type,"dismissible":"","transition":"scale-transition"}},[_vm._v("\n      "+_vm._s(alert.message)+"\n    ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }